import {ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, OnInit, Output} from '@angular/core';
import {
  AbstractControl,
  UntypedFormControl,
  UntypedFormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors, Validators,
} from "@angular/forms";
import {CoreService} from "../../../../../services/core/core.service";
import {first, pairwise, startWith} from "rxjs/operators";
import {SharedService} from "../../../../shared/shared.service";
import {Subscription} from "rxjs";
import {JobsiteDataService} from "../../../../jobsite/jobsite.data.service";
import {ToasterService} from "../../../../../services/core/toaster.service";
import {CreateJobsiteComponent} from "../../../../jobsite/create-jobsite/create-jobsite.component";
import {DialogService} from "../../../../../services/core/dialog.service";
import {CustomerCreateEditComponent} from "../../../../customer/customer-create-edit/customer-create-edit.component";
import {
  CustomerComponentsCommunicationServiceService
} from "../../../../customer/service/customer-components-communication-service.service";
import { SubofficeService } from 'src/app/modules/setting/company-settings/suboffice/suboffice.service';


@Component({
    selector: 'app-jobsite-address-form',
    templateUrl: './jobsite-address-form.component.html',
    styleUrls: ['./jobsite-address-form.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => JobsiteAddressFormComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => JobsiteAddressFormComponent),
            multi: true
        }
    ],
    standalone: false
})
export class JobsiteAddressFormComponent implements OnInit {

  @Input() model: any = {};
  @Input() form: any = {};
  @Input() defaultJobsiteName: string | null = null;
  @Input() isEdit: boolean = false;
  @Output() callback = new EventEmitter<any>(true);
  @Output() onInitForm = new EventEmitter<any>(true);

  public allJobsites: any[] = [];
  public jobsites: any[] = [];
  public jobsite: any = {};
  public jobSiteAddressChangesFlag: boolean = false;
  public addNewJobSiteFlag: boolean = false;
  public addressComponentData: any = this.initAddressComponentData(this.model, true);
  public jobSiteFormSubscription: Subscription = new Subscription();
  public customerJobSiteSubscription: Subscription = new Subscription();
  public tenantIdSubscription: Subscription = new Subscription();

  public jobsiteForm: UntypedFormGroup = new UntypedFormGroup({
    name: new UntypedFormControl(null),
    email: new UntypedFormControl(null),
    phone: new UntypedFormControl(null),
    jobsiteAddress: new UntypedFormControl(null),
    jobsite_id: new UntypedFormControl(null, [Validators.required]),

    // city: new UntypedFormControl(null),
    // job_site_address1: new UntypedFormControl(null),
    // job_site_address2: new UntypedFormControl(null),
    // state: new UntypedFormControl(null),
    // zipcode: new UntypedFormControl(null),
  });

  constructor(
    private jobsiteDataService: JobsiteDataService,
    public dialogService: DialogService,
    public toasterService: ToasterService,
    public sharedService: SharedService,
    public coreService: CoreService,
    private cd: ChangeDetectorRef,
    public customerComponentCommunicationService: CustomerComponentsCommunicationServiceService,
    public subofficeService: SubofficeService
  ) {
  }

  ngOnInit(): void {
    this.initSubscriptions();
    // this.getJobsites();
    this.seDefaultAddressData();

    this.tenantIdSubscription = this.subofficeService.tenantId$.subscribe((tenantId) => {

      if(typeof tenantId == 'number') {
        this.getJobsites({ tenant_id: tenantId });
      }

    });

  }
  seDefaultAddressData(){
    this.addressComponentData = this.initAddressComponentData(this.model, true);
    console.log('setDataOnEdit', this.addressComponentData);

  }

  setDataOnEdit = () => {
    if (this.isEdit) {
      // this.jobsiteForm?.get('jobsite_id')?.setValue({id: this.model?.jobsite?.id, name: this.model?.jobsite?.address});
      this.getJobsite({id: this.model?.jobsite?.id});
      const jobSite = this.getJobSiteById(this.model?.jobsite?.id);
      this.jobsiteForm?.get('jobsite_id')?.setValue(this.makeJobSiteDropDownData(jobSite));

      // this.jobsiteForm?.get('estimator_id')?.setValue({id:this.model?.estimator?.id, name: this.model?.estimator?.full_name});
      //  this.jobsiteForm?.get('sales_rep_id')?.setValue({id:this.model?.sales_rep?.id, name: this.model?.sales_rep?.full_name});
    }
  }

  getJobsites = (queryParam: any) => {
    this.sharedService.getJobsites(queryParam)
      .pipe(first())
      .subscribe(
        (data: any) => {
          this.allJobsites = data?.data
          this.jobsites = this.allJobsites?.map((jobsite: any) => {
            return this.makeJobSiteDropDownData(jobsite);
          });
          this.setDataOnEdit();
        });
  }
  makeJobSiteDropDownData(job: any){
    return {id: job.id, name: `${job.title}`};
  }

  onSelectJobsite = (event: any) => {
    console.log('setDataOnEdit onSelectJobsite', this.model);
    this.getJobsite(event);
    this.jobSiteAddressChangesFlag = true;
    this.addressComponentData = this.initAddressComponentData(this.jobsite);

    this.cd.detectChanges();
    this.jobSiteAddressChangesFlag = false;

  }

  initAddressComponentData(value: any = '', isFromDefault = false) {
    console.log('setDataOnEdit', value);
    return {
      address_line_1: !isFromDefault ?  value?.address : value?.address_line_1,
      address_line_2: !isFromDefault ?  value?.address2 : value?.address_line_2 ,
      relations: {
        state: !isFromDefault ?  value?.relations?.state : value?.state,
      },
      city: !isFromDefault ?  value?.city : value?.city,
      zipcode: !isFromDefault ?  value?.zipcode : value?.zipcode
    };
  }

  getJobsite = (event: any) => {
    if (event) {
      this.jobsite = this.allJobsites.filter((jobsite: any) => {
        return event.id === jobsite.id;
      });
    }
    return this.jobsite = (this.jobsite.length > 0) ? this.jobsite[0] : [];
  }
  getJobSiteById(id: string){
   return  this.allJobsites.find((jobsite: any) => {
      return id === jobsite.id;
    });
  }

  addNewJobSite(e: any) {
    const dialogData = (this.defaultJobsiteName != null && this.defaultJobsiteName !== '')
      ? {default_title: this.defaultJobsiteName } : {};
    this.dialogService.onOpenDialog(CreateJobsiteComponent, dialogData, 900, '98vh');
    this.dialogService.afterClose()?.subscribe((result: any) => {
      if(result) {
        this.addNewJobSiteData(result.data.data);
      }
    });
  }

  addNewJobSiteData(jobSite: any) {
    console.log('addNewJobSiteData', jobSite);
    const jobSiteObj = { id: jobSite.id, name: jobSite.title };
    this.jobsites.push(jobSiteObj);
    this.allJobsites.push(jobSite);
    this.jobsiteForm.get('jobsite_id')?.setValue(jobSiteObj);
    this.onSelectJobsite(jobSiteObj);
    this.updateDropdownItems();
  }

  updateDropdownItems() {

    this.jobsites = [...this.jobsites];
  }

  public onTouched: () => void = () => {
  };

  writeValue(val: any): void {
    val && this.jobsiteForm.setValue(val, {emitEvent: false});
  }

  registerOnChange(fn: any): void {
    this.jobsiteForm.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.jobsiteForm.disable() : this.jobsiteForm.enable();
  }

  validate(c: AbstractControl): ValidationErrors | null {
    return this.jobsiteForm.valid ? null : {invalidForm: {valid: false, message: "Job site Form are invalid"}};
  }

  initChildForm(value: any) {
    this.jobsiteForm.get('jobsiteAddress')?.setValue(value);
    this.onInitForm.emit(this.jobsiteForm);
  }

  initSubscriptions() {
    if (this.form) {
      this.jobSiteFormSubscription = this.form.valueChanges
        .pipe(startWith(null), pairwise())
        .subscribe(([prev, next]: [any, any]) => {
          if (this.form.touched) {
            this.touchFormControls();
            // this.createNewJobSite()
            console.log('this.form.touched', this.form.touched);
          }
        });
    }


    this.customerJobSiteSubscription = this.customerComponentCommunicationService.getCustomerJobSiteValue()
      .subscribe((response: any) => {
        console.log('response jobsite', response.jobsite);
        // this.getJobsites();
        // this.jobsites.push({id: response.jobsite?.id, name: response?.jobsite?.title});
        this.addNewJobSiteData(response?.jobsite)
      })
  }

  touchFormControls() {
    Object.keys(this.jobsiteForm.controls).forEach(key => {
      this.jobsiteForm.get(key)?.markAsTouched();
    });
  }

  createNewJobSite() {
    console.log('this.jobsiteForm', this.jobsiteForm);
    if (this.jobsiteForm.invalid) {
      this.toasterService.showWarning('Please fill all required fields!')
      return;
    }
    this.jobsiteDataService.create(this.jobsiteForm.value)
      .pipe(first())
      .subscribe(
        data => {
          console.log('data', data);
        });
  }


  getFormData = () => {
    const jobsiteForm = this.jobsiteForm.getRawValue();
    let data = {
      name: jobsiteForm?.name,
      email: jobsiteForm?.email,
      phone: jobsiteForm?.phone,
      address: jobsiteForm?.jobsiteAddress?.address_line_1,
      address2: jobsiteForm?.jobsiteAddress?.address_line_2,
      city: jobsiteForm?.jobsiteAddress?.city,
      country_id: 231,
      state_id: jobsiteForm?.jobsiteAddress?.state_id?.id,
      zipcode: jobsiteForm?.jobsiteAddress?.zipcode,
    }
    return data;
  }

  ngOnDestroy() {
    // prevent memory leak when component destroyed
    this.jobSiteFormSubscription?.unsubscribe();
    this.customerJobSiteSubscription?.unsubscribe();
    this.tenantIdSubscription?.unsubscribe();
  }

}
